import { ComponentChildren, h } from 'preact'
import Icon from '../assets'
import Tooltip from '../ui-components/Tooltip'

interface Props {
  children: ComponentChildren,
  className?: string
}

const TopicMore = ({ children, className }: Props) => {
  return (
    <div className={`post-footer-item text--meta post-footer-item_show-more ${className || ''}`}>
      <Tooltip
        withArrow
        trigger={(
          <Icon size={16} icon='moreHoriz' />
        )}
        tooltipMessage={(
          <ul className='post-footer-item_show-more-list'>
            { children }
          </ul>
        )}
      />
    </div>
  )
}

export default TopicMore
